module.exports = "<div id='not-found'>\r\n    <div id='error-text'>\r\n      <span>{{ \"code\" | translate: \"ERR404\" }}</span>\r\n      <p>{{ \"name\" | translate: \"ERR404\" }}</p>\r\n      <p class='hmpg'><a href='#' class=\"back\">{{ \"button\" | translate: \"ERR404\" }}</a></p>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/errors/404.component.html
// module id = 700
// module chunks = 63